import React, { useState } from 'react';
import './CommonStyles.css';
import './Products.css';
import './Accounting.css';
import ChartOfAccounts from './accounting/ChartOfAccounts';
import JournalEntry from './accounting/JournalEntry';
import Transfer from './accounting/Transfer';
import Transactions from './accounting/Transactions';
import Budget from './accounting/Budget';
import AccountingReports from './accounting/AccountingReports';
import AccountingSettings from './accounting/AccountingSettings';

const TABS = [
  { key: 'chart', label: 'Chart of Accounts' },
  { key: 'journal', label: 'Journal Entry' },
  { key: 'transfer', label: 'Transfer' },
  { key: 'transactions', label: 'Transactions' },
  { key: 'budget', label: 'Budget' },
  { key: 'reports', label: 'Reports' },
  { key: 'settings', label: 'Settings' },
];

const Accounting = () => {
  const [activeTab, setActiveTab] = useState('chart');

  const renderTab = () => {
    switch (activeTab) {
      case 'chart': return <ChartOfAccounts />;
      case 'journal': return <JournalEntry />;
      case 'transfer': return <Transfer />;
      case 'transactions': return <Transactions />;
      case 'budget': return <Budget />;
      case 'reports': return <AccountingReports />;
      case 'settings': return <AccountingSettings />;
      default: return <ChartOfAccounts />;
    }
  };

  return (
    <div className="accounting-module-container">
      <div className="accounting-header-area">
        <h2 className="accounting-page-title">Accounting & Finance</h2>
        <p className="accounting-page-subtitle">Manage your accounts, journal entries, and financial settings</p>
      </div>

      <div className="accounting-tabs-wrapper">
        {TABS.map(t => (
          <button
            key={t.key}
            className={`accounting-tab-btn ${activeTab === t.key ? 'active' : ''}`}
            onClick={() => setActiveTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="accounting-content-area">
        {renderTab()}
      </div>
    </div>
  );
};

export default Accounting;
